__turbopack_context__.v({
  "button": "show-more-module__VrY3DG__button",
  "content": "show-more-module__VrY3DG__content",
  "is-open": "show-more-module__VrY3DG__is-open",
});
